<template>
  <div>
    <div v-for="({ type, theme, ...section }, i) in data.section" :key="i" :index="i" :class="theme">
      <component :is="`${type}`" :key="i" class="pb-24" v-bind="{ ...section, theme }" :index="i" />
    </div>
  </div>
</template>

<script lang="ts" setup>
const route = useRoute()

const slug = computed(() => {
  if (route.path === '/') return 'homepage'
  return route?.params?.slug as string ?? ''
})

const { data } = await useAsyncData('page-' + slug.value, () => queryContent('/pages/' + slug.value).findOne(), { watch: [slug], transform: data => correctAssetRoutes(data) })

if (!data.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Not Found',
  })
}
const url = useRuntimeConfig().public.siteUrl

const canonical = computed(() => {
  if (route.path === '/') return url
  return url + route.path
})

useHead({
  title: data.value.title,
  templateParams: {
    siteUrl: url,
    // @ts-expect-error untyped
    trailingSlash: route.path.endsWith('/'),
  },
  link: [
    {
      rel: 'canonical',
      href: canonical.value,
    },
  ],
})
const settings = useState<Settings>('settings')
useSeoMeta({
  description: () => data?.value?.metadescription ?? data?.value?.brief ?? data.value?.description,
  ogTitle: () => `IPC Partners | ${data.value?.title}`,
  ogDescription: () => data?.value?.metadescription ?? data.value?.description,
  ogImage: () => data.value?.metaimage,
  twitterTitle: () => `IPC Partners | ${data.value?.title}`,
  twitterDescription: () => data?.value?.metadescription ?? data.value?.description,
  twitterImage: () => data.value?.metaimage,
})
</script>

<style scoped></style>
